// extracted by mini-css-extract-plugin
export default {"heading":"Mr-z","corrected":"Nr-z","redirectVerbiageContainer":"Or-z","redirectVerbiageText":"Pr-z"};